import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export default function ConfirmationAlert(props) {
  const { show, message, onConfirm, onCancel } = props;
  return (
    <SweetAlert
      title={message}
      warning
      show={show}
      showCancel
      reverseButtons
      cancelBtnBsStyle="danger"
      confirmBtnText="Ya"
      cancelBtnText="Tidak"
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      Setelah mengkonfirmasi tindakan tidak dapat dibatalkan.
    </SweetAlert>
  );
}
